import { emailRegEx } from '@/core';

export const validateEmail = (email: string): boolean => {
  return !!email.match(emailRegEx);
};
